import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import HelpModal from './HelpModal.js';
import { getHelpContent } from './helpContent.js';
import './HelpButton.css';

/**
 * Opens contextual help (videos + documentation) for a configured page.
 * @param {{ pageId: string, className?: string, 'aria-label'?: string }} props
 */
const HelpButton = ({ pageId, className = '', 'aria-label': ariaLabel = 'Help' }) => {
  const [open, setOpen] = useState(false);
  const content = getHelpContent(pageId);

  if (!content) {
    return null;
  }

  const hasVideos = (content.videos || []).length > 0;
  const hasDocs = (content.documentation || []).length > 0;
  if (!hasVideos && !content.videosComingSoon && !hasDocs) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={`help-button ${className}`.trim()}
        onClick={() => setOpen(true)}
        aria-label={ariaLabel}
        title={ariaLabel}
      >
        <FontAwesomeIcon icon={faQuestionCircle} />
      </button>
      {open && <HelpModal pageId={pageId} onClose={() => setOpen(false)} />}
    </>
  );
};

export default HelpButton;
